/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

// TODO: Check if SwipeableDrawer from @one-thd/sui-atomic-components can be reused
// and extra functionality can be added in this file
/**
 * A container for the drawer component.
 *
 * @param { ContainerProps } props - The properties for the DrawerContainer component.
 * - `children`: Content to display inside the drawer.
 * - `dynamicStyles`: Dynamic classes passed to the container.
 * - `className`: Additional classes to pass to the container.
 * @param { React.ForwardedRef<HTMLDivElement> } ref - Reference to the DrawerContainer element.
 *
 * @returns {JSX.Element} The DrawerContainer component.
 */
export const DrawerContainer = React.forwardRef(({
  children,
  dynamicStyles,
  className,
  ...other
}, ref) => {
  const classes = [
    'drawer-container sui-flex sui-flex-col sui-overflow-y-hidden sui-bg-primary sui-z-max sui-outline-none sui-max-w-full sui-w-full sui-rounded-t-lg sui-bottom-0 sui-left-0 sui-transition-[height] sui-duration-500',
    className
  ].join(' ');

  return (
    <div
      className={classes}
      style={dynamicStyles}
      ref={ref}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
    >
      {children}
    </div>
  );
});

DrawerContainer.displayName = 'DrawerContainer';

DrawerContainer.propTypes = {
  dynamicStyles: PropTypes.shape({ [PropTypes.string]: PropTypes.string }).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

DrawerContainer.defaultProps = {
  className: undefined,
};
